import { SHOWING_RESULT_TIME, GAMESTATE } from '@config/constants.js';
import { convertArrToObj } from '@utils/odds.js';

const isEmpty = (myObject) => {
  for(const key in myObject) {
      // eslint-disable-next-line no-prototype-builtins
      if (myObject.hasOwnProperty(key)) {
          return false;
      }
  }
  return true;
};

export const showResult = (container, newVal,
    animationTime = SHOWING_RESULT_TIME.ANIMATION_TIME,
    resultTime = SHOWING_RESULT_TIME.RESULT_TIME,
    isSetScore = true,
    isHighlightResult = true,
  ) => {
  if(isEmpty(container.odds)){
    container.odds = convertArrToObj(newVal.odds);
  }

  const that = container;

  // showing animation
  container.gameState = GAMESTATE.SHOWING_RESULT;
  container.timeout = 0;
  container.round = newVal.id;

  // set score
  container.setResult(newVal);

  // set flip result score

  const score = { ...container.data.score };
  container.flipScore = { ...score };

  setTimeout(function(){
    // waiting 6s to set dices result
    that.setHistory(newVal);

    // set score
    if(isSetScore){
      that.score = { ...score };
    }

  }, animationTime);

  setTimeout(function(){
    // waiting 8s to button result
    // that.score.isHighlight = true;
    if(isHighlightResult){
      that.isHighlightResult = true;
    }

    // start waiting
    if(that.newRound === that.round){
      that.gameState = GAMESTATE.WAITING_NEW_GAME;
    }else {  // or start new game
      that.round = that.newRound;
      that.gameState = GAMESTATE.BETTING;
      that.timeout = that.timeBet;
      that.clearBetValue(that.table);
    }
  }, resultTime);

  setTimeout(function(){
    that.isHighlightResult = false;
  }, resultTime + 2000);

};

export const startNewGame = (container, { id, timeBet, odds, jackpot }) => {
  if(isEmpty(container.odds)){
    container.odds = convertArrToObj(odds);
  }

  container.jackpot = jackpot;

  if(container.gameState === GAMESTATE.WAITING_NEW_GAME ||
    container.gameState === GAMESTATE.LOCKING
  ){
    container.round = id;
    container.newRound = id;
    container.gameState = GAMESTATE.BETTING;
    container.timeout = timeBet;
    container.clearBetValue(container.table);
  }else {
    container.newRound = id;
    container.timeBet = timeBet;
  }
};


